import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import ForgotPasswordComponent from '../../Modals/ForgotPassword';
import validate from './validate';
import { renderField, renderCheckbox } from '../../../utils/renderFields';
import { fetchLogin } from '../../../actions/auth';

import './styles.scss';

class LoginForm extends React.Component {

  constructor(props){
    super(props);
    this.passwordReset = this.passwordReset.bind(this);
    this.submit = this.submit.bind(this);
  }

  passwordReset(e){
    e.preventDefault();
    this.props.removeModal();
    modal.add(ForgotPasswordComponent, {title:'', size:'medium', hideTitleBar:true})
  }

  submit(values) {
    return this.props.dispatch(fetchLogin(values, window.location.pathname, this.props.removeModal));
  }

  render() {
    const { error, handleSubmit, pristine, submitting, errors } = this.props;
    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <span className={error ? 'has-danger' : ''}>
          <span className="u-textSize-18 form-control-feedback">{error}</span>
        </span>
        <Field component={renderField} name="email" type="email" label="Email Address" className="form-control u-textSize-18" hiddenLabel />
        <Field component={renderField} type="password" name="password" className="form-control u-textSize-18" label="Password" hiddenLabel />
        <div className="remember-me-wrap form-group">
          <Field component={renderCheckbox} type="checkbox" name="remember_me" label="Remember me" className="form-check u-textSize-20"/>
        </div>
        <div className="align-items-md-center d-flex submit-row">
          <div className="col p-0">
            <a href="#" className="u-textSize-18" onClick={this.passwordReset}><span>Forgot Password?</span></a>
          </div>
          <div className="col text-right">
            <button className="btn btn-primary" type="submit" disabled={submitting}>Log In</button>
          </div>
        </div>
      </form>
    );
  }
}

LoginForm = reduxForm({form: 'loginForm', validate, fields:['email','password','remember_me']})(LoginForm);
export default connect(null)(LoginForm);
